import React from 'react';
import { format, isToday, formatDistanceToNowStrict } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import './RowTile.scss';
import { RootState } from '../../../configs/store';
import { getFlag } from '../../../utils/utils';
import logo2 from '../../../assets/images/betxchange-logo2.png';
import CountDown from '../../../components/CountDown/CountDown';
import Button from '../../../components/Button/Button';

interface RowTileProps {
  event: {
    numbersRules:
      {
        imageMobile: string,
        imageDesktop: string,
      },
    description: string
    countryCode: string,
    name: string,
    eventStart: number,
    code: number,
    eventId: number,
    cardCode: number,
    couponCode: number
  },
  showCodes: boolean
}

function RowTile({ event, showCodes }: RowTileProps) {
  const { t } = useTranslation('common');
  const location = useLocation();
  const { selectedTimezone } = useSelector((state: RootState) => state.odds);
  const { hasCountDown } = useSelector((state: RootState) => state.content);

  const eventStart = event.eventStart * 1000;
  const date = utcToZonedTime(eventStart, selectedTimezone);
  const formattedDate = format(date, 'EEE, MMM dd, HH:mm');
  const isSameDay = isToday(eventStart);
  const dateCountDown = formatDistanceToNowStrict(eventStart, { unit: 'minute', addSuffix: true });
  const notSameDayDate = format(date, 'EEE, MMM dd, HH:mm');

  return (
    <div className="row-tile">
      <div className="row-tile__information">
        <img
          className="row-tile__image"
          src={ event.numbersRules?.imageDesktop ? event.numbersRules.imageDesktop : logo2 }
          alt={ event.name }
        />
        <div
          className="tile__flag"
          style={ { backgroundImage: `url(${ getFlag(event.countryCode) })` } }
        />
        <h4 className="row-tile__event-name">{
          showCodes && event.cardCode ?
            `${ event.name } - ${ event.cardCode }/${ event.couponCode }` :
            event.name
        }</h4>
      </div>
      <div className="row-tile__schedule">
        { isSameDay ? formattedDate : notSameDayDate }
      </div>
      <div className="row-tile__count-down">
        { hasCountDown && <CountDown timeTillDate={ eventStart } /> }
        {
          !hasCountDown &&
        <div className="row-tile__schedule">
          { dateCountDown  }
        </div>
        }
        <Button
          className="btn--primary row-tile__button"
          size="medium"
          text={ t('numbers.playNow') }
          link= { `/lotto/${ event.code }/${ event.eventId }${ location.search }` }
        />
      </div>
    </div>
  );
}

export default RowTile;
